module.exports = __webpack_public_path__ + "img/teeth-open.888fe899.svg";